import { render, staticRenderFns } from "./GoodsPopup.vue?vue&type=template&id=d0b8c054&scoped=true"
import script from "./GoodsPopup.vue?vue&type=script&lang=js"
export * from "./GoodsPopup.vue?vue&type=script&lang=js"
import style0 from "./GoodsPopup.vue?vue&type=style&index=0&id=d0b8c054&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0b8c054",
  null
  
)

export default component.exports